import { heating_circuits_icons } from 'console/shared/components/fields/icon/icons';
import { useHeatingDeviceConfig } from 'console/shared/contexts/heating-device/config';
import { useMemo } from 'react';
import { isLegacyDevice } from 'console/shared/contexts/device/config/utils';
import { selectSelectedDevice } from 'entities/device/lib';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { useDesignPackage } from 'console/shared/hooks/helpers';
import { heating_circuits_custom_icons } from 'console/shared/components/fields/icon/icons/heating-circuits';
/**
 * @function
 * Получаем цвет и подсказку, чтобы показать в каком режиме работает контур
 * @param heating_modes - режимы контуров
 * @param mode_id - id режима текущего контура
 * @param summer_mode - режим лето
 */
export function getHeatingCircuitColor(heating_modes, mode_id, summer_mode) {
    if (summer_mode) {
        return { color: '#f57f17', tooltip: 'Контур в летнем режиме, управления нет' };
    }
    const circuit_mode = heating_modes?.find((mode) => mode.id === mode_id);
    const tooltip = circuit_mode?.name && `Работает в режиме ${circuit_mode.name}`;
    const color = circuit_mode?.color;
    return { color, tooltip };
}
export const useHeatingCircuitIcon = (id, isBoiler) => {
    const { heating_circuits_icons: heating_circuits_icons_config, boiler_heating_circuits_icons: boiler_heating_circuits_icons_config, } = useHeatingDeviceConfig();
    const device_type = useAppSelector((state) => selectSelectedDevice(state)?.device_type);
    const heating_circuit_icon = useMemo(() => heating_circuits_icons_config ? heating_circuits_icons_config[id] : null, [heating_circuits_icons_config, id]);
    const boiler_heating_circuits_icon = useMemo(() => boiler_heating_circuits_icons_config
        ? boiler_heating_circuits_icons_config[id]
        : null, [boiler_heating_circuits_icons_config, id]);
    const allow_design_package = useDesignPackage();
    const icons = useMemo(() => allow_design_package
        ? heating_circuits_icons
        : heating_circuits_custom_icons, [allow_design_package]);
    const icon = useMemo(() => {
        if (typeof heating_circuit_icon === 'string') {
            if (allow_design_package) {
                return heating_circuit_icon;
            }
        }
        if (typeof boiler_heating_circuits_icon === 'string') {
            if (allow_design_package) {
                return boiler_heating_circuits_icon;
            }
        }
        if (isBoiler && isLegacyDevice(device_type)) {
            return icons.find((settings_icon) => settings_icon.id === boiler_heating_circuits_icon)?.render;
        }
        else {
            return icons.find((settings_icon) => settings_icon.id === heating_circuit_icon)?.render;
        }
    }, [heating_circuit_icon, boiler_heating_circuits_icon, icons]);
    return icon;
};
